<canvas #canvas class="block w-full h-full"></canvas>
